<template>
    <div>
        <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link> /
            <router-link :to="{name: 'admin-master' }" class="root">
                Admin Master
            </router-link>
            <span class="child">/ TestCenterOffering</span>
        </v-row><br />
        <v-card class="card">
            <v-card-title class="heading justify-center">Test Center Offering</v-card-title>
            <v-dialog v-model="dialog_delete" persistent max-width="400px">
                <v-card>
                    <v-container>
                        <h3><strong>Are you sure you want Delete this Test Center Offering ???</strong></h3>
                        <v-row justify="center">
                            <v-btn class="button-cancel mr-2" @click="dialog_delete = false">No</v-btn>
                            <v-btn class="button" @click="deleteOperation(item)">Yes</v-btn>
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
            <v-card-text>
                <v-data-table :headers="headers" :items="role_list" class="elevation-1 nowrap" :search="search">
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                            <span style="width: 20px"></span>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on }">
                                    <v-btn class=" button" v-on="on">Add Test Center Offering</v-btn>
                                </template>
                                <v-card>
                                    <v-form v-model="valid">
                                        <v-card-title class="heading">
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" sm="12" md="12 ">
                                                        <v-text-field dense v-model="editedItem.capacity"
                                                            v-on:keypress="isNumber($event)" item-text="role_list_id"
                                                            item-value="id" persistent-hint
                                                            :hint="editedIndex==-1?'':''" label="Capacity"
                                                            :error="errorMsg.capacity?true:false"
                                                            :error-messages="errorMsg.capacity?'Required':''"
                                                            :rules="[v => !!v || 'required']"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="12" md="12">
                                                        <v-autocomplete :items="usertype_list" item-value="id"
                                                            item-text="name" v-model="editedItem.testCenterId"
                                                            label="Choose Test Center"
                                                            :error="errorMsg.testCenterId?true:false"
                                                            :error-messages="errorMsg.testCenterId?'Required':''"
                                                            :rules="[v => !!v || 'required']"></v-autocomplete>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="12" md="12">
                                                        <v-autocomplete :items="examDate_list" item-value="id"
                                                            item-text="exam_date" v-model="editedItem.examdateId"
                                                            label="Choose Exam Date"
                                                            :error="errorMsg.examdateId?true:false"
                                                            :error-messages="errorMsg.examdateId?'Required':''"
                                                            :rules="[v => !!v || 'required']"></v-autocomplete>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" sm="6" md="4">
                                                        <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                            label="Active"></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="button-cancel" text @click="close">Cancel</v-btn>
                                            <v-btn class="button" @click="save" :disabled="!valid">Save</v-btn>
                                        </v-card-actions>
                                    </v-form>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>

                    <template v-slot:item.isactive="{ item }">
                        <span v-if="item.isactive">
                            <v-icon class="mr-2  v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2  v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>

                    <template v-slot:item.action="{ item }">
                        <div>
                            <v-avatar style="" size="25" class="edit-avatar">
                                <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                            </v-avatar>
                        </div>
                    </template>
                    <template v-slot:item.actions1="{ item }">
                        <v-btn icon @click="deletedialog(item)" color="error">
                            <v-icon>mdi-delete-circle</v-icon></v-btn>
                    </template>
                </v-data-table>
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import axios from 'axios'
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            valid: false,
            dialog_delete: false,
            overlay: false,
            errorMsg: {
                roleId: false
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: '',
            org: '',
            dialog: false,
            headers: [
            {
                text: 'Test Center',
                align: 'left',
                sortable: false,
                value: 'testcentername',
            },
            {
                text: 'Test Center Address',
                align: 'left',
                sortable: false,
                value: 'testcenteraddress',
            },
            {
                text: 'Code',
                align: 'left',
                sortable: false,
                value: 'testcentercode',
            },
            {
                text: 'Capacity',
                align: 'left',
                sortable: true,
                value: 'capacity',
            },
            {
                text: 'Active',
                align: 'left',
                sortable: true,
                value: 'isactive',
            },
            {
                text: 'Actions',
                value: 'action',
                sortable: false
            },
            { text: 'Delete', value: 'actions1', sortable: false },
            ],
            role_list: [],
            usertype_list: [],
            examDate_list: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                capacity: '',
                testCenterId: '',
                examdateId: '',
                isactive: false
            },
            defaultItem: {
                id: '',
                capacity: '',
                testCenterId: '',
                examdateId: '',
                isactive: false
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Test Center Offering Name' : 'Edit Test Center Offering Name';
                return /^[A-Za-z]+$/.test(this.capacity);
            },

        },

        watch: {
            dialog(val) {
                val || this.close()
            },
            overlay(val) {
                val = () => {
                    this.overlay = false
                };
            },
        },

        // created () {
        //   this.initialize()
        // },
        mounted() {
            this.onLoad()
        },
        methods: {
            isNumber: function (evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 45) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
            //   initialize () {

            //   },

            editItem(item) {

                this.editedIndex = this.role_list.indexOf(item)
                this.editedItem = Object.assign({}, item)

                this.dialog = true
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("/AdminMaster/adminTestCenterOffering")
                    .then(res => {
                        if (res.data.msg == "200") {
                            //window.alert(res.data.msg)
                            if (this.load = true) {
                                this.overlay = false;
                                this.role_list = res.data.role_list
                                this.usertype_list = res.data.usertype_list
                                this.examDate_list = res.data.examDate_list
                                this.org = res.data.org
                            }
                        } else {
                            window.console.log(res.data.msg)
                        }
                    })
                    .catch(error => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        var overlay = false;
                    });
            },
            deletedialog(item) {
                //alert(item)
                console.log(item)
                this.dialog_delete = true;
                this.delete_id = item.roleId;
            },
            deleteOperation() {
                //alert("delete")
                let formData = new FormData();
                console.log("delete id"+this.delete_id);
                formData.append("id", this.delete_id);
                axios
                    .post("/AdminMaster/deleteTestCenteroffering", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.showSnackbar("#4CAF50", "Test Center deleted successfully...");
                            this.dialog_delete = false;
                            this.onLoad();
                        } else if (res.data.status == "NO") {
                            this.showSnackbar("error", "You can not delete this operation!!!");
                            this.dialog_delete = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.dialog_delete = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                if (this.editedIndex > -1) {
                    if (this.isValidated()) {
                        axios
                            .post("/AdminMaster/editTestCenterOffering", this.editedItem)
                            .then(res => {
                                if (res.data.status.code == "SUCCESS") {
                                    //window.alert(res.data.msg)
                                    Object.assign(this.role_list[this.editedIndex], this.editedItem);
                                    this.showSnackbar(
                                        "#4caf50",
                                        "Test Center Offering Updated Successfully..."
                                    ); // show snackbar on success
                                } else if (res.data.status.code == "NA") {
                                    this.showSnackbar("#b71c1c", "Test Center Offering Already Present!!!"); // show snackbar on error
                                }
                            })
                            .catch(error => {
                                window.console.log(error);
                            });
                        this.close()
                    }
                } else {
                    axios
                        .post("/AdminMaster/saveTestCenterOffering", this.editedItem)
                        .then(res => {
                            if (res.data.status.code == "SUCCESS") {
                                //window.alert(res.data.status.code)
                                this.role_list.push(this.editedItem)
                                this.showSnackbar("#4caf50", "Test Center Offering Added Successfully!!!"); // show snackbar on success
                                this.onLoad()
                            } else if (res.data.status.code == "NA") {
                                //window.alert(res.data.status.code)
                                // alert(res.data.status.message)
                                this.showSnackbar("#b71c1c", "Test Center Offering Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch(error => {
                            window.console.log(error);
                        });
                    this.close()
                }
            }, //save()
            isValidated() {
                if (this.editedItem.roleId) {
                    return true;
                } else {
                    if (!this.editedItem.roleId) {
                        this.errorMsg.roleId = true
                    }

                    return false;
                }
            }, // .....end of isValidated()
        },
    }
</script>

<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
</style>